/**
 * The LayersChangeDetector class detects the kind of changes
 * in overlay layers over time comparing old and new values
 */
export class LayersChangeDetector {
    getChanges(currentOverlayLayers, oldOverlayLayers) {
        return {
            added: this.addedLayers(currentOverlayLayers, oldOverlayLayers),
            removed: this.removedLayers(currentOverlayLayers, oldOverlayLayers),
            modified: this.modifiedLayers(currentOverlayLayers, oldOverlayLayers),
        };
    }
    /**
     * Function that compares current layers and old layers and returns the ones that have been added
     * @param currentOverlayLayers Current layers
     * @param oldOverlayLayers Old layers
     * @returns The layers that have been added
     */
    addedLayers(currentOverlayLayers, oldOverlayLayers) {
        const addedLayerIds = [];
        const currentLayerIds = currentOverlayLayers.map((el) => el.id);
        const oldLayerIds = oldOverlayLayers.map((el) => el.id);
        currentLayerIds.forEach((currentLayerId) => {
            if (oldLayerIds.indexOf(currentLayerId) === -1) {
                addedLayerIds.push(currentLayerId);
            }
        });
        return currentOverlayLayers.filter((layer) => addedLayerIds.indexOf(layer.id) > -1);
    }
    /**
     * Function that compares current layers and old layers and returns the ones
     * that have been removed
     * @param currentOverlayLayers Current layers
     * @param oldOverlayLayers Old layers
     * @returns The layers that have been removed
     */
    removedLayers(currentOverlayLayers, oldOverlayLayers) {
        const removedLayerIds = [];
        const currentLayerIds = currentOverlayLayers.map((el) => el.id);
        const oldLayerIds = oldOverlayLayers.map((el) => el.id);
        oldLayerIds.forEach((oldLayerId) => {
            if (currentLayerIds.indexOf(oldLayerId) === -1) {
                removedLayerIds.push(oldLayerId);
            }
        });
        return oldOverlayLayers.filter((layer) => removedLayerIds.indexOf(layer.id) > -1);
    }
    /**
     * Function that compares current layers and old layers and returns the ones
     * that have been modified
     * @param currentOverlayLayers Current layers
     * @param oldOverlayLayers Old layers
     * @returns The layers that have been modified
     */
    modifiedLayers(currentOverlayLayers, oldOverlayLayers) {
        const modifiedLayers = [];
        oldOverlayLayers.forEach((oldLayer) => {
            const currentLayer = currentOverlayLayers.find((el) => el.id === oldLayer.id);
            if (currentLayer) {
                const modifiedFields = this.getModifiedFields(currentLayer, oldLayer);
                if (modifiedFields && modifiedFields.length > 0) {
                    modifiedLayers.push({ overlayLayer: currentLayer, modifiedFields });
                }
            }
        });
        return modifiedLayers;
    }
    /**
     * Compares two overlay layers in order to detect properties that have changed
     * @param currentOverlayLayer current layer
     * @param oldOverlayLayer old layer
     * @returns An array od the fields that have been modified. If something important changed like
     * uel or layers, modifiedField contains reset in order to remove and add layer again
     */
    getModifiedFields(currentOverlayLayer, oldOverlayLayer) {
        const modifiedFields = [];
        if (currentOverlayLayer.isVisible !== oldOverlayLayer.isVisible) {
            modifiedFields.push('visibility');
        }
        if (currentOverlayLayer.type === 'OverlayEmptyLayer') {
            modifiedFields.push('visibility');
        }
        if (currentOverlayLayer.opacity !== oldOverlayLayer.opacity) {
            modifiedFields.push('opacity');
        }
        if (currentOverlayLayer.url !== oldOverlayLayer.url) {
            // Reset means we have to remove and add this layer again because some
            // immutable field has changed
            modifiedFields.push('reset');
        }
        if (JSON.stringify(currentOverlayLayer.layers)
            !== JSON.stringify(oldOverlayLayer.layers)) {
            // Reset means we have to remove and add this layer again because some
            // immutable field has changed
            modifiedFields.push('reset');
        }
        return modifiedFields;
    }
}
//# sourceMappingURL=layersChangeDetector.js.map